import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';

import { FormService } from '@form-field-module/common/services/form.service';
import { FormCommonDataService } from '@form-field-module/common/services/form-common-data.service';
import { ClientForm } from '@form-field-module/common/models/client-form.model';
import { AttachmentBase } from '@sb-tools/typescript/models/attachment-base.model';
import { FormType } from '@sb-tools/typescript/enums/form-type.enum';
import { CheckFormInitDirective } from '../../../../sb-modules/Frontend-form-field-module/common/directives/check-form-init.directive';
import { NgClass } from '@angular/common';
import { FormFieldComponent } from '../../../../sb-modules/Frontend-form-field-module/form-field/form-field.component';
import { CheckFieldRulesDirective } from '../../../../sb-modules/Frontend-form-field-module/common/directives/check-field-rules.directive';

@Component({
    selector: 'app-form-component',
    templateUrl: './form.component.html',
    styleUrls: ['./form.component.scss'],
    imports: [FormsModule, CheckFormInitDirective, NgClass, FormFieldComponent, CheckFieldRulesDirective],
})
export class FormComponent implements OnInit {
    @Input() attachments?: AttachmentBase[];
    @Input() attachmentsBlockTemplate?: TemplateRef<any>;
    @Input() form: ClientForm;
    @Input() formType: FormType;
    @Input() isFormFieldsWithRules: boolean;

    @ViewChild('ticketForm') ticketForm: NgForm;

    constructor(
        public formService: FormService,
        private formCommonDataService: FormCommonDataService,
    ) {}

    ngOnInit(): void {
        this.formCommonDataService.setFocusOnFirstFocusableElement(this.form.fields);
    }
}
